import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import StartTime from "./StartTime.js";
const useStyles = makeStyles((theme) => ({}));
function Hourly(props) {
  // const [monthsValue, setMonthsValue] = useState(1);
  const [dayOfMonthValue, setDayOfMonthValue] = useState(1);
  const classes = useStyles();
  const [startTime, setStartTime] = useState({ minutes: 0, hours: 0 });
  // useEffect(
  //   () => {
  //     props.returnValue(value, startTime);
  //   },
  //   [value]
  // );
  const returnValue = (value) => {
    setDayOfMonthValue(value);
    props.returnValue(value, startTime);
  };

  const returnStartTime = (time) => {
    setStartTime(time);
    props.returnValue(dayOfMonthValue, time);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", marginTop: 20 }}>
      {/* <div>
        <TextField
          id="outlined-number"
          label="Day of the month(s)"
          value={monthsValue}
          onChange={(e) =>
            e.target.value <= 12 &&
            e.target.value >= 0 &&
            setMonthsValue(e.target.value)
          }
          type="number"
          margin="normal"
          variant="outlined"
        />
      </div> */}
      <div>
        <TextField
          id="outlined-number"
          label="Day of every month(s)"
          value={dayOfMonthValue}
          onChange={(e) =>
            e.target.value >= 1 &&
            e.target.value <= 31 &&
            returnValue(e.target.value)
          }
          type="number"
          margin="normal"
          variant="outlined"
        />
      </div>
      <StartTime returnValue={(value) => returnStartTime(value)} />
    </div>
  );
}

export default Hourly;
